import React from 'react';

const StageBanner = ({ stage }) => {
    if (!stage) return null;

    const { order, name, description, stage_color } = stage;

    return (
        <div
            className="w-full p-4 rounded-2 flex flex-col gap-2"
            style={{ backgroundColor: stage_color || '#E6EDE6' }}
        >
            <div className="flex items-center gap-2">
                <div className="min-w-[24px] h-6 rounded-full bg-black font-body-bold text-body-bold-s text-white flex items-center justify-center">
                    {order}
                </div>
                <p className="font-body-bold text-body-bold-l text-black">{name}</p>
            </div>

            <p className="font-body text-body-regular-m text-neutral-500 whitespace-pre-wrap">
                {description}
            </p>
        </div>
    );
};

export default StageBanner;
